import React from 'react'
import ReportGmailerrorredRoundedIcon from '@mui/icons-material/ReportGmailerrorredRounded'
import { Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import useStyles from './_styles'
import { ErrorDisclaimerProps } from './_props'

const ErrorDisclaimer = ({ label = 'Une erreur est survenue', cancelButton, reloadButton }: ErrorDisclaimerProps) => {
    const classes = useStyles()
    const navigate = useNavigate()

    const handleReload = () => {
        if (reloadButton?.action) reloadButton.action()
        else window.location.reload()
    }
    const handleGoBack = () => {
        if (cancelButton?.action) cancelButton.action()
        else navigate(-1)
    }

    return (
        <div className={classes.ErrorDisclaimer}>
            <div className={classes.ErrorDisclaimerContainer}>
                <div className={classes.ErrorDisclaimerIconContainer}>
                    <ReportGmailerrorredRoundedIcon className={classes.ErrorDisclaimerIcon} />
                </div>
                <Typography className={classes.ErrorDisclaimerText}>{label}</Typography>
                <div className={classes.ErrorDisclaimerButtonsContainer}>
                    <Button color="inherit" onClick={handleGoBack}>
                        {cancelButton?.label ?? 'Retour'}
                    </Button>
                    <Button variant="contained" disableElevation onClick={handleReload}>
                        {reloadButton?.label || 'Recharger'}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default ErrorDisclaimer
